<ng-scrollbar>
  <div
    class="container teacher-theme flex column justify-center align-items-center"
  >
    <ut-card padding="none">
      <h3 ut-card-title>
        <app-language-switch class="p-1"></app-language-switch>
        @if (!imageUuid) {
          <img src="/assets/img/training-load-960x540.jpg" />
        }
        @if (imageUuid) {
          <app-s3-img [uuid]="imageUuid"></app-s3-img>
        }
        <div class="content">
          <ng-content select="[titleContent]"></ng-content>
        </div>
        <div class="mt-1 title text">{{ pageTitle | translate }}</div>
      </h3>
      <div ut-card-content class="pb-2">
        <ng-content select="[content]"></ng-content>
      </div>
    </ut-card>
  </div>
</ng-scrollbar>
